<main class="w-full h-full">
  <IntersectionObserver
    element="{element}"
    once
    bind:intersecting
    on:intersect="{() => {
      console.log(`Intersecting-element: ${source}-${id}`)
    }}">
    <div class="relative inset-0" bind:this="{element}" id="{id}">
      {#if intersecting}
        <Player id="{id}" story="{story}" stories_="{stories_}" {...$$props} />
      {/if}

      <Overlay story="{story}" />
    </div>
  </IntersectionObserver>
</main>

<Tailwind />

<script>
  import '~/amp/amp-player.js'

  import Overlay from '~/components/Overlay.svelte'
  import Player from '~/components/Player.svelte'
  import Tailwind from '~/components/Tailwind.svelte'

  import IntersectionObserver from 'svelte-intersection-observer'

  import { isEmpty, uniqBy } from 'lodash-es'
  import { configuration } from '~/store/index.js'

  // props
  export let source, config, story, stories, id

  // eslint-disable-next-line no-unused-vars
  $: config, ($configuration = config)

  $: stories, serializeStories()

  // Variables
  let element,
    intersecting,
    stories_ = []

  async function serializeStories() {
    stories_ = await getStoriesToBeShown()
  }

  async function getStoriesToBeShown() {
    if (isEmpty(stories)) return
    let storiesToBeShown

    storiesToBeShown = [...stories]

    if (config.limit) return storiesToBeShown.slice(0, config.limit)

    if (config['load-more'])
      return uniqBy([...storiesToBeShown, ...stories], 'id')

    return [story || storiesToBeShown[0]]
  }
</script>
